var map = {
	"./about-image": 6,
	"./about-image-2": 7,
	"./about-image-2.jpg": 7,
	"./about-image.jpg": 6,
	"./big-slider-image": 8,
	"./big-slider-image.jpg": 8,
	"./cafe": 9,
	"./cafe.jpg": 9,
	"./chairs": 10,
	"./chairs.svg": 10,
	"./close": 11,
	"./close.svg": 11,
	"./enlarge": 12,
	"./enlarge.svg": 12,
	"./facebook-social": 13,
	"./facebook-social.svg": 13,
	"./favicon": 14,
	"./favicon.svg": 14,
	"./footer-logo": 15,
	"./footer-logo.svg": 15,
	"./hero": 16,
	"./hero.jpg": 16,
	"./instagram-social": 17,
	"./instagram-social.svg": 17,
	"./left-arrow": 18,
	"./left-arrow.svg": 18,
	"./linkedin-social": 19,
	"./linkedin-social.svg": 19,
	"./lm-og-logo": 20,
	"./lm-og-logo.png": 20,
	"./logo-dark": 21,
	"./logo-dark.svg": 21,
	"./logo-light": 22,
	"./logo-light.svg": 22,
	"./marker": 23,
	"./marker.svg": 23,
	"./new-colored-logo": 24,
	"./new-colored-logo.svg": 24,
	"./new-favicon": 25,
	"./new-favicon.svg": 25,
	"./new-white-logo": 26,
	"./new-white-logo.svg": 26,
	"./open-graph-image": 27,
	"./open-graph-image.jpg": 27,
	"./preview-image": 28,
	"./preview-image.jpg": 28,
	"./service-image": 29,
	"./service-image.jpg": 29,
	"./sofa-image": 30,
	"./sofa-image.jpg": 30,
	"./stone-stairs": 31,
	"./stone-stairs.jpg": 31,
	"./stopwatch": 32,
	"./stopwatch.svg": 32,
	"./twitter-social": 33,
	"./twitter-social.svg": 33,
	"./wood": 34,
	"./wood-swatches/dark-brown-wood": 5,
	"./wood-swatches/dark-brown-wood.jpg": 58,
	"./wood-swatches/dark-brown-wood.png": 5,
	"./wood.svg": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;